import AdminScanning from "./AdminScanning";

function App() {
  return <AdminScanning />;
}

export default App;
